import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiClientConfig} from '../api-client-config';
import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {
  DataNature,
  DataNatureCreateRequest,
  DataNatureCreateResponse,
  DataNatureDetails,
  DataNatureUpdateRequest,
  DataNatureUpdateResponse,
} from '@ms-organization-entities';
import {ColumnWithLocalization} from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

@Injectable({
  providedIn: 'root'
})
export class NatureOfDataService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/data-natures/';
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<DataNature> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<DataNature>(url, request);
  }

  public getNatureOfDatas(): Observable<DataNature[]> {
    const url = this.endpoint;
    return this.httpClient.get<DataNature[]>(url);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  // public updateUserColumns(columnsConfigurationUpsertRequest: ColumnsConfigurationUpsertRequest): Observable<void> {
  //   const url = this.endpoint + 'user-columns';
  //   return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  // }

  public getCategories(): Observable<string[]> {
    const url = this.endpoint + 'categories/';
    return this.httpClient.get<string[]>(url);
  }

  public getNatureOfDataById(id: number): Observable<DataNature> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<DataNature>(url);
  }

  public getNatureOfDataDetails(id: number): Observable<DataNatureDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<DataNatureDetails>(url);
  }

  public deleteNatureOfData(id: number): Observable<DataNature> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<DataNature>(url);
  }

  public createNatureOfData(requestBody: DataNatureCreateRequest): Observable<DataNatureCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<DataNatureCreateResponse>(url, requestBody);
  }

  public updateNatureOfData(id: number, requestBody: DataNatureUpdateRequest): Observable<DataNatureUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<DataNatureUpdateResponse>(url, requestBody);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }
}
